import { useState } from 'react'
import { Menu, MenuItem, useTheme } from '@material-ui/core'
import Link from '../utility/CustomLink'
import NestedMenuItem from '../ui/NestedMenuItem'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'

// to use this in put menuObjects like this
// const menuObjects = [
//   {
//     label: 'label',
//     href: 'href',
//     handleClick: 'handleClick function',
//     danger: 'is danger',
//     nested: 'menuObjects', // if have nested menu
//   },
// ]

const DropdownMenuSp = ({ children, menuId, menuObjects }) => {
  // menuObjects = [{label:node,handleClick:function}]
  const theme = useTheme()
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const renderNormalMenuItem = (item) => (
    <MenuItem
      onClick={item.handleClick || (() => {})}
      key={item.label}
      className={item.danger && 'danger'}
    >
      {item.label}
    </MenuItem>
  )

  const renderMenuItems = () => {
    let returnList = []
    for (let i = 0; i < menuObjects.length; i++) {
      let jsx = null
      if (!menuObjects[i].nested)
        jsx = renderNormalMenuItem(menuObjects[i])
      else if (menuObjects[i].nested)
        jsx = (
          <NestedMenuItem
            label={menuObjects[i].label}
            parentMenuOpen={Boolean(anchorEl)}
            rightIcon={<ChevronRightIcon fontSize="small" />}
            key={i}
          >
            {menuObjects[i].nested.map(item => {
              if (!item.href) return renderNormalMenuItem(item)
              else return (
                <Link href={item.href} passHref key={i}>
                  <a title={item.label}>{renderNormalMenuItem(item)}</a>
                </Link>
              )
            })}
          </NestedMenuItem>
        )
      if (!menuObjects[i].href) returnList.push(jsx)
      else
        returnList.push(
          <Link href={menuObjects[i].href} passHref key={i}>
            <a title={menuObjects[i].label}>{jsx}</a>
          </Link>
        )
    }
    return returnList
  }

  return (
    <>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          onClick: handleClick,
          'aria-controls': menuId,
          'aria-haspopup': true,
        })
      })}
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: -15,
          horizontal: 'left',
        }}
        elevation={2}
      >
        {renderMenuItems()}
      </Menu>
    </>
  )
}

export default DropdownMenuSp
